import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import customStylesSelect from '@styles/react-select';
import ButtonComp from '@components/UI/Button/Index.jsx';

function FilterView({ filters, setFilters, filterLabels, customFieldComponents = {} }) {
  const [selectedOption, setSelectedOption] = useState(null);
  const [tempValues, setTempValues] = useState(filters);

  useEffect(() => {
    setTempValues(filters);
  }, [filters]);

  const options = Object.keys(filters).map((key) => ({
    value: key,
    label: filterLabels[key],
  }));

  const handleInputChange = (e) => {
    const value = e.target.value;
    setTempValues((prev) => ({
      ...Object.fromEntries(Object.keys(filters).map((k) => [k, ""])),
      [selectedOption?.value]: value,
    }));
  };

  const handleCustomChange = (value) => {
    setTempValues((prev) => ({
      ...Object.fromEntries(Object.keys(filters).map((k) => [k, ""])),
      [selectedOption.value]: value,
    }));
  };

  const handleApply = () => setFilters(tempValues);

  const handleClear = () => {
    setTempValues(Object.fromEntries(Object.keys(filters).map((k) => [k, ""])));
    setFilters(Object.fromEntries(Object.keys(filters).map((k) => [k, ""])));
    setSelectedOption(null);
  };

  return (
    <div className="col-12 mt-5 mb-5">
      <hr />
      <h2 className="mb-3">Filtragem dos dados Cadastrados</h2>
      <div className="row g-2 align-items-end">
        {/* Select: ocupa 12 colunas em mobile, 3 colunas a partir do md */}
        <div className="col-12 col-md-3">
          <Select
            className="react-select-container"
            classNamePrefix="react-select"
            name="campoFiltro"
            value={selectedOption}
            onChange={setSelectedOption}
            options={options}
            placeholder="Selecione o campo"
            isClearable
            isSearchable={false}
            styles={customStylesSelect}
          />
        </div>
        {/* Input: ocupa 12 colunas em mobile, 6 colunas a partir do md */}
        <div className="col-12 col-md-6">
          {selectedOption && customFieldComponents[selectedOption.value] ? (
            React.createElement(customFieldComponents[selectedOption.value], {
              value: tempValues[selectedOption.value],
              onChange: handleCustomChange,
              style: { width: '100%' }
            })
          ) : (
            <input
              type="text"
              className="form-control"
              style={{ height: '2.375rem', width: '100%' }}
              name={selectedOption?.value}
              value={tempValues[selectedOption?.value] || ''}
              onChange={handleInputChange}
              placeholder={
                selectedOption
                  ? `Digite para filtrar por ${selectedOption.label.toLowerCase()}`
                  : 'Selecione o campo a ser filtrado'
              }
              disabled={!selectedOption}
            />
          )}
        </div>
        {/* Botões: ocupa 12 colunas em mobile, 3 colunas a partir do md */}
        <div className="col-12 col-md-3 d-flex justify-content-end gap-1 mt-2">
          <ButtonComp
            type="button"
            onClick={handleApply}
            title="Buscar"
            classnameIcon="fa-solid fa-filter"
            buttonColor="#2b97be"
            hoverMessage="Buscar"
          />
          <ButtonComp
            type="button"
            onClick={handleClear}
            title="Limpar"
            classnameIcon="fa-regular fa-circle-xmark"
            buttonColor="#125578"
            hoverMessage="Limpar filtros"
          />
        </div>
      </div>
    </div>
  );
}

export default FilterView;